export const TestId = {
  root: 'filtersPanel',
  closeButton: 'filtersPanelClose',
  applyButton: 'filtersApplyButton',
  clearButton: 'filtersClearButton',
}
